var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79208 14.5404C9.6425 14.5404 9.51479 14.4888 9.40896 14.3858C9.30299 14.2827 9.25 14.1551 9.25 14.0029C9.25 13.8505 9.30194 13.7215 9.40583 13.6158C9.50958 13.5099 9.63819 13.457 9.79167 13.457H18.2079C18.3575 13.457 18.4852 13.5086 18.591 13.6116C18.697 13.7147 18.75 13.8423 18.75 13.9945C18.75 14.1469 18.6981 14.2759 18.5942 14.3816C18.4904 14.4874 18.3618 14.5404 18.2083 14.5404H9.79208Z",
    fill: "#A7B0C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDisabled);
export default __webpack_public_path__ + "static/media/remove_disabled.bd00d98e97793f5d2dfa7f2b2648ca82.svg";
export { ForwardRef as ReactComponent };